import { DateSchema } from 'yup';

import { MIN_DOB_DATE, MIN_DOB_YEAR } from 'constants/patients';

/**
 * An extension for yup's DateSchema to validate that a date is not in the future.
 *
 * Sample usage: `yup.date().pastOrToday().required()`
 */
export function pastOrToday(message = 'Must be today or earlier'): DateSchema {
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  return this.test('pastOrToday', message, function validatePastOrTodayDate(value: Date) {
    let isValid = true;

    if (value) {
      const now = new Date();
      isValid = value.valueOf() <= now.valueOf();
    }

    // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
    return isValid || this.createError({ path: this.path });
  });
}

/**
 * An extension for yup's DateSchema to validate a date of birth.
 * Validates that the date is not in the future and not before the minimum DOB year (1900).
 *
 * Sample usage: `yup.date().validDateOfBirth().required()`
 */
export function validDateOfBirth(this: DateSchema): DateSchema {
  return this.test(
    'validDateOfBirth',
    `Year must be ${MIN_DOB_YEAR} or later`,
    function validateDateOfBirth(value: Date) {
      if (!value) {
        return true;
      }

      const now = new Date();
      if (value.valueOf() > now.valueOf()) {
        return this.createError({ path: this.path, message: 'Must be today or earlier' });
      }

      if (value.valueOf() < MIN_DOB_DATE.valueOf()) {
        return this.createError({
          path: this.path,
          message: `Year must be ${MIN_DOB_YEAR} or later`,
        });
      }

      return true;
    },
  );
}

/**
 * An extension for yup's DateSchema to validate that a date is in the future.
 *
 * Sample usage: `yup.date().future().required()`
 */
export function future(this: DateSchema, message = 'Must be in the future'): DateSchema {
  return this.test('future', message, function validateFutureDate(value: Date) {
    let isValid = true;

    if (value) {
      const now = new Date();
      isValid = value.valueOf() > now.valueOf();
    }

    return isValid || this.createError({ path: this.path, message });
  });
}
